import { render, staticRenderFns } from "./paySucess.vue?vue&type=template&id=474782d2&scoped=true"
import script from "./paySucess.vue?vue&type=script&lang=js"
export * from "./paySucess.vue?vue&type=script&lang=js"
import style0 from "./paySucess.vue?vue&type=style&index=0&id=474782d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474782d2",
  null
  
)

export default component.exports